export const SHOW_RESEND_TIMEOUT = 30000;
export const WARNING_TIMEOUT = 30000;


// WEBPACK FOOTER //
// ./src/v2/view-builder/utils/Constants.js